import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {api_routes} from '@app/consts';
import {EmployeeBankDetails, EmployeeBankDetailSubmit} from '../models/employee-bank-details.model';
import {EnvironmentService} from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeBankDetailsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getBankDetails(employeeId: string, take?: number, skip?: number, filterString?: string, sortString?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    filterString ? params = params.append('filter', filterString) : null;
    sortString ? params = params.append('sort', sortString) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BANK_DETAILS}`, {
      headers: headers,
      params: params
    });
  }

  deleteBankDetail(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BANK_DETAILS}/${id}`, {
      headers: headers
    });
  }

  getBankDetail(employeeId: string, id: string): Observable<EmployeeBankDetails> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BANK_DETAILS}/${id}`, {
      headers: headers
    });
  }

  updateBankDetail(employeeId: string, employeeBankDetail: EmployeeBankDetailSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BANK_DETAILS}/${employeeBankDetail.id}`, employeeBankDetail, {
      headers: headers
    });
  }

  createBankDetail(employeeId: string, employeeBankDetail: EmployeeBankDetailSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BANK_DETAILS}`, employeeBankDetail, {
      headers: headers
    });
  }
}
